import { mq, Text, useSecondaryThemeColor } from "@pallet-hq/hegel"
import { useTheme } from "@emotion/react"
import styled from "@emotion/styled"

export type FeaturedWrapperProps = {
    isVisible: boolean
}

export const FeaturedWrapper = ({ isVisible }: FeaturedWrapperProps) => {
    // @ts-ignore
    const { colors } = useTheme()
    const featuredTagColor = useSecondaryThemeColor()

    return (
        <StyledWrapper color={colors.primary} isVisible={isVisible}>
            <Text
                variant="uiSmall600"
                color={featuredTagColor}
                m="xsmall"
                textAlign="center"
            >
                Most Popular
            </Text>
        </StyledWrapper>
    )
}

const StyledWrapper = styled.div<{ color: string; isVisible: boolean }>`
    background: ${({ color }) => color};
    visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
    ${({ isVisible }) =>
        mq({ display: [isVisible ? "block" : "none", "block"] })}
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
`
